export default __webpack_public_path__ + "static/media/red-suo.5db21bd0.svg";